import { useEffect, useRef } from 'react'
import { AdriverSrc } from 'Pages/landings/newLandings/common/constants'
import { CONTOUR, getContour } from '@pp/axios'

export const useAdriverPixel = (pathname: string) => {
	const containerRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (getContour() === CONTOUR.DEV || getContour() === CONTOUR.UAT || !containerRef.current)
			return

		const RndNum4NoCash = Math.round(Math.random() * 1000000000).toString()
		const ar_Tail = document.referrer ? encodeURIComponent(document.referrer) : 'unknown'

		const url = AdriverSrc[pathname]
			.replace(':RndNum4NoCash', RndNum4NoCash)
			.replace(':ar_Tail', ar_Tail)

		const img = document.createElement('img')
		img.src = url
		img.width = 1
		img.height = 1
		img.style.display = 'none'
		img.referrerPolicy = 'no-referrer-when-downgrade'

		containerRef.current.append(img)

		return () => {
			img.remove()
		}
	}, [pathname])

	return containerRef
}
